import React from 'react'
import profile from '../Images/mint.jpg'
import {FaGithub, FaTwitter, FaLinkedinIn, FaEnvelope, FaInstagram} from 'react-icons/fa';
import Typical from 'react-typical';

export default function Card() {
  return (
    <div className='w-full'>
      
         <div className="flex flex-col justify-center max-w-xs mx-auto bg-white bg-opacity-10 shadow-xl rounded-2xl p-5 2xl:mt-10 relative z-2 border border-opacity-20 border-r-0 border-b-0 backdrop-filter backdrop-blur-sm">
              <div className=" ">
                  <img className='w-32 mx-auto shadow-5xl rounded-full drop-shadow-sm' src={profile} alt=''/>
              </div>
               <div className='text-center mt-5'>
                  <p className='text-xl sm:text-2xl text-white'>
                      Anurag Singh Bhadauria 
                   </p>

                   <p className='text-xs text-gray-400 sm:text-base  pt-4 pb-4 px-5 w-auto'>
                     I'm a {' '}
                      <Typical
                      loop={Infinity}
                      wrapper="b"
                      steps={[
                        'Developer',
                        2000,
                        'Coder',
                        1500,
                        'Software Engineer',
                        2000,
                        'Learner',
                        1000
                      ]}
                      />
                   </p>

                  <div className='flex align-center justify-center mt-4'>
                      
                      <a rel="noreferrer" className='text-xl m-1 p-1 sm:m-2 sm:p-2 text-pink-700 hover:bg-rose-700 rounded-full hover:text-white transition-colors duration-300' href='https://instagram.com/_anuraag_' target="_blank">
                        <FaInstagram/>
                        <span className='sr-only'>Instagram</span>
                      </a>

                      <a rel="noreferrer" className='text-xl m-1 p-1 sm:m-2 sm:p-2 text-sky-400 hover:bg-sky-400 rounded-full hover:text-white transition-colors duration-300' href='https://twitter.com/anurrag_' target="_blank">
                        <FaTwitter/>
                        <span className='sr-only'>Twitter</span>
                      </a>

                      <a rel="noreferrer" className='text-xl m-1 p-1 sm:m-2 sm:p-2 text-black-800 hover:bg-black-800 rounded-full hover:text-white transition-colors duration-300' href='https://github.com/singhanurrag' target="_blank">
                        <FaGithub/>
                        <span className='sr-only'>Github</span>
                      </a>

                      <a rel="noreferrer" className='text-xl m-1 p-1 sm:m-2 sm:p-2 text-blue-700 hover:bg-blue-500 rounded-full hover:text-white transition-colors duration-300' href='https://www.linkedin.com/in/anuragsbhadauria/' target="_blank">
                        <FaLinkedinIn/>
                        <span className='sr-only'>LinkedIn</span>
                      </a>

                      <a rel="noreferrer" className='text-xl m-1 p-1 sm:m-2 sm:p-2 text-yellow-500 hover:bg-green-500 rounded-full hover:text-white transition-colors duration-300' href='https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=bhadauriaanurag2000@gmail.com' target="_blank">
                        <FaEnvelope/>
                        <span className='sr-only'>FaEnvelope</span>
                      </a>
                  </div>
               </div>
        </div>
    </div>
  )
}
   